/** @deprecated will be removed when dropping backward compatibility for old DND */
const SCROLL_STATES = {
    Start: 'scrollStart',
    IsScrolling: 'isScrolling',
    End: 'scrollEnd',
};
const OUTGOING_EVENTS = {
    Connected: 'connected',
    DesignTokens: 'registerDesignTokens',
    RegisteredBreakpoints: 'registeredBreakpoints',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    MouseMove: 'mouseMove',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentSelected: 'componentSelected',
    RegisteredComponents: 'registeredComponents',
    RequestComponentTreeUpdate: 'requestComponentTreeUpdate',
    CanvasReload: 'canvasReload',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    UpdateSelectedComponentCoordinates: 'updateSelectedComponentCoordinates',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    CanvasScroll: 'canvasScrolling',
    CanvasError: 'canvasError',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    OutsideCanvasClick: 'outsideCanvasClick',
    SDKFeatures: 'sdkFeatures',
    RequestEntities: 'REQUEST_ENTITIES',
    CanvasGeometryUpdated: 'canvasGeometryUpdated',
    CanvasPan: 'canvasPan',
};
const INCOMING_EVENTS = {
    RequestEditorMode: 'requestEditorMode',
    RequestReadOnlyMode: 'requestReadOnlyMode',
    ExperienceUpdated: 'componentTreeUpdated',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentDraggingChanged: 'componentDraggingChanged',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentDragCanceled: 'componentDragCanceled',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentDragStarted: 'componentDragStarted',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentDragEnded: 'componentDragEnded',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    ComponentMoveEnded: 'componentMoveEnded',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    CanvasResized: 'canvasResized',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    SelectComponent: 'selectComponent',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    HoverComponent: 'hoverComponent',
    UpdatedEntity: 'updatedEntity',
    /** @deprecated not needed after `patternResolution` was introduced. Will be removed in the next major version. */
    AssembliesAdded: 'assembliesAdded',
    /** @deprecated not needed after `patternResolution` was introduced. Will be removed in the next major version. */
    AssembliesRegistered: 'assembliesRegistered',
    /** @deprecated will be removed when dropping backward compatibility for old DND */
    MouseMove: 'mouseMove',
    RequestedEntities: 'REQUESTED_ENTITIES',
};
const INTERNAL_EVENTS = {
    ComponentsRegistered: 'cfComponentsRegistered',
    VisualEditorInitialize: 'cfVisualEditorInitialize',
};
const VISUAL_EDITOR_EVENTS = {
    Ready: 'cfVisualEditorReady',
};
/**
 * These modes are ONLY intended to be internally used within the context of
 * editing an experience inside of Contentful Studio. i.e. these modes
 * intentionally do not include preview/delivery modes.
 */
var StudioCanvasMode;
(function (StudioCanvasMode) {
    StudioCanvasMode["READ_ONLY"] = "readOnlyMode";
    StudioCanvasMode["EDITOR"] = "editorMode";
    StudioCanvasMode["NONE"] = "none";
})(StudioCanvasMode || (StudioCanvasMode = {}));
const VISUAL_EDITOR_CONTAINER_ID = 'cf-visual-editor';
const CONTENTFUL_COMPONENT_CATEGORY = 'contentful-component';
const CONTENTFUL_DEFAULT_CATEGORY = 'Contentful';
const CONTENTFUL_COMPONENTS = {
    section: {
        id: 'contentful-section',
        name: 'Section',
    },
    container: {
        id: 'contentful-container',
        name: 'Container',
    },
    columns: {
        id: 'contentful-columns',
        name: 'Columns',
    },
    singleColumn: {
        id: 'contentful-single-column',
        name: 'Column',
    },
    button: {
        id: 'contentful-button',
        name: 'Button',
    },
    heading: {
        id: 'contentful-heading',
        name: 'Heading',
    },
    image: {
        id: 'contentful-image',
        name: 'Image',
    },
    richText: {
        id: 'contentful-richText',
        name: 'Rich Text',
    },
    text: {
        id: 'contentful-text',
        name: 'Text',
    },
    divider: {
        id: 'contentful-divider',
        name: 'Divider',
    },
    carousel: {
        id: 'contentful-carousel',
        name: 'Carousel',
    },
};
const ASSEMBLY_NODE_TYPE = 'assembly';
const ASSEMBLY_DEFAULT_CATEGORY = 'Assemblies';
const ASSEMBLY_BLOCK_NODE_TYPE = 'assemblyBlock';
const ASSEMBLY_NODE_TYPES = [ASSEMBLY_NODE_TYPE, ASSEMBLY_BLOCK_NODE_TYPE];
const LATEST_SCHEMA_VERSION = '2023-09-28';
const CF_STYLE_ATTRIBUTES = [
    'cfVisibility',
    'cfHorizontalAlignment',
    'cfVerticalAlignment',
    'cfMargin',
    'cfPadding',
    'cfBackgroundColor',
    'cfWidth',
    'cfMaxWidth',
    'cfHeight',
    'cfImageAsset',
    'cfImageOptions',
    'cfBackgroundImageUrl',
    'cfBackgroundImageOptions',
    'cfFlexDirection',
    'cfFlexWrap',
    'cfFlexReverse',
    'cfBorder',
    'cfBorderRadius',
    'cfGap',
    'cfColumnSpan',
    'cfColumnSpanLock',
    'cfColumns',
    'cfFontSize',
    'cfFontWeight',
    'cfLineHeight',
    'cfLetterSpacing',
    'cfTextColor',
    'cfTextAlign',
    'cfTextTransform',
    'cfTextBold',
    'cfTextItalic',
    'cfTextUnderline',
];
const EMPTY_CONTAINER_SIZE = '80px';
const HYPERLINK_DEFAULT_PATTERN = `/{locale}/{entry.fields.slug}/`;
var PostMessageMethods;
(function (PostMessageMethods) {
    PostMessageMethods["REQUEST_ENTITIES"] = "REQUEST_ENTITIES";
    PostMessageMethods["REQUESTED_ENTITIES"] = "REQUESTED_ENTITIES";
})(PostMessageMethods || (PostMessageMethods = {}));
const SUPPORTED_IMAGE_FORMATS = ['jpg', 'png', 'webp', 'gif', 'avif'];

export { ASSEMBLY_BLOCK_NODE_TYPE, ASSEMBLY_DEFAULT_CATEGORY, ASSEMBLY_NODE_TYPE, ASSEMBLY_NODE_TYPES, CF_STYLE_ATTRIBUTES, CONTENTFUL_COMPONENTS, CONTENTFUL_COMPONENT_CATEGORY, CONTENTFUL_DEFAULT_CATEGORY, EMPTY_CONTAINER_SIZE, HYPERLINK_DEFAULT_PATTERN, INCOMING_EVENTS, INTERNAL_EVENTS, LATEST_SCHEMA_VERSION, OUTGOING_EVENTS, PostMessageMethods, SCROLL_STATES, SUPPORTED_IMAGE_FORMATS, StudioCanvasMode, VISUAL_EDITOR_CONTAINER_ID, VISUAL_EDITOR_EVENTS };
//# sourceMappingURL=constants.js.map
